export class GetMPARequestResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaRequestDetail",
            "baseName": "mpaRequestDetail",
            "type": "MPARequestDetail",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetMPARequestResponse.attributeTypeMap;
    }
    constructor() {
    }
}
